import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ConsumidorService } from '../../../services/consumidor.service';
import { ControllAppService } from '../../../../../services/controllApp.service';
import { DatePipe } from '@angular/common';
import { catchError, forkJoin, map, of } from 'rxjs';
declare var bootstrap: any;

// Interface para o modelo de dados da auditoria
interface AuditoriaItem {
  auditoriaId: string;
  usuarioId: string;
  nomeUsuario: string;
  papel: string;
  acao: string;
  entidade: string;
  entidadeId: string;
  resumo: string;
  dataHora: string;
}

@Component({
  selector: 'app-auditoria',
  standalone: false,
  templateUrl: './auditoria.component.html',
  styleUrls: ['./auditoria.component.css'],
  providers: [DatePipe]
})
export class AuditoriaComponent implements OnInit {
  filtroForm: FormGroup;
  resultados: AuditoriaItem[] = []; // Ensure this array is defined
  carregando = false;
  erroCarregamento = false;
  mensagemErro = '';
  nomesUsuarios: string[] = []; // <-- Adicionado

  // Metadados de paginação
  paginaAtual = 1;
  totalPaginas = 0;
  totalItens = 0;
  itensPorPagina = 10;
  private readonly nomesPorUsuarioId = new Map<string, string>();

  // Opções para o filtro de tipo de entidade e ação
  tiposEntidade = ['Recadastro', 'Cadastro e Recadastro', 'Cadastro'];
  tiposAcao = [
    'Atualizou o status da Vistoria',
    'Atribuiu uma vistoria',
    'Entrou no sistema',
    'Exclusão de Cadastros',
    'Exportacao Automatica - Erro',
    'Exportacao Automatica - Sem Dados',
    'Exportacao Automatica - Sucesso',
    'Exportacao Automatica Agendada - Erro',
    'Exportacao Automatica Agendada - Sem Dados',
    'Exportacao Automatica Agendada - Sucesso',
    'Exportacao Manual Arquivo - Erro',
    'Exportacao Manual Arquivo - Sem Dados',
    'Exportacao Manual Arquivo - Sucesso',
    'Exportacao Manual Cadastros - Erro',
    'Exportacao Manual Cadastros - Sem Dados',
    'Exportacao Manual Cadastros - Sucesso',
    'Exportacao Manual Item - Erro',
    'Exportacao Manual Item - Sucesso',
    'Exportacao Manual Recadastros - Erro',
    'Exportacao Manual Recadastros - Sem Dados',
    'Exportacao Manual Recadastros - Sucesso',
    'Exportacao Sucesso - Remocao Erro',
    'Exportacao Sucesso - Remocao Sem Registro',
    'Exportacao Sucesso - Removida',
    'Finalizou o cadastro',
    'Finalizou um Recadastro',
    'Iniciou Análise de um Cadastro',
    'Iniciou Análise de um Recadastro',
    'Iniciou o Cadastro',
    'Iniciou o Recadastramento',
    'Logout Automático',
    'Mudança de Status para Pendente',
    'Mudança de Status para Validado',
    'Negativa de Atendimento',
    'Realizou o cadastro',
    'Realizou um Recadastro',
    'Saiu do sistema'
  ];
  resumoModal: string | null = null;
  resumoVisivel: number | null = null;

  constructor(
    private fb: FormBuilder,
    private consumidorService: ConsumidorService,
    private controllAppService: ControllAppService,
    private datePipe: DatePipe
  ) {
    // Obter data atual para definir como filtro padrão
    const hoje = new Date();
    const dataHojeFormatada = this.formatDataParaInput(hoje);
    
    this.filtroForm = this.fb.group({
      entidade: [''],
      acao: [''],
      dataInicio: [dataHojeFormatada], // Valor padrão: data atual
      dataFim: [dataHojeFormatada],     // Valor padrão: data atual
      nomeUsuario: [''] // novo controle
    });
  }

  ngOnInit(): void {
    this.carregarDados();
  }

  // Formata a data para o formato aceito pelo input type="date" (YYYY-MM-DD)
  // com ajuste para evitar problemas de fuso horário
  formatDataParaInput(data: Date): string {
    // Ajusta a data para o fuso horário local para evitar problemas de offset
    const dataLocal = new Date(data);
    dataLocal.setMinutes(dataLocal.getMinutes() + dataLocal.getTimezoneOffset());
    
    const ano = dataLocal.getFullYear();
    const mes = (dataLocal.getMonth() + 1).toString().padStart(2, '0');
    const dia = dataLocal.getDate().toString().padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  }

  carregarDados(resetarPagina = true): void {
    if (resetarPagina) {
      this.paginaAtual = 1;
    }

    this.carregando = true;
    this.erroCarregamento = false;
    this.resultados = []; // Limpar resultados anteriores
    
    const filtros = this.filtroForm.value;
    
    // Formatar datas se existirem
    let dataInicio: string | undefined = undefined;
    if (filtros.dataInicio) {
      // Garantir que estamos trabalhando com o dia correto, desconsiderando o timezone
      const dataInicioObj = new Date(filtros.dataInicio + 'T00:00:00');
      dataInicioObj.setHours(0, 0, 0, 0);
      const formattedDate = this.datePipe.transform(dataInicioObj, 'yyyy-MM-ddTHH:mm:ss');
      if (formattedDate) {
        dataInicio = formattedDate;
      }
    }
    
    let dataFim: string | undefined = undefined;
    if (filtros.dataFim) {
      // Garantir que estamos trabalhando com o dia correto, desconsiderando o timezone
      const dataFimObj = new Date(filtros.dataFim + 'T00:00:00');
      dataFimObj.setHours(23, 59, 59, 999);
      const formattedDate = this.datePipe.transform(dataFimObj, 'yyyy-MM-ddTHH:mm:ss');
      if (formattedDate) {
        dataFim = formattedDate;
      }
    }

    this.consumidorService.consultarAuditoria(
      undefined, // usuarioId
      filtros.entidade || undefined,
      filtros.nomeUsuario || undefined, // nome → 3ª posição
      filtros.acao || undefined,         // acao → 4ª posição
      dataInicio,
      dataFim,
      this.paginaAtual,
      this.itensPorPagina
    ).subscribe({
      next: (response) => {
        
        // Verificar estrutura da resposta
        if (response) {
          if (Array.isArray(response)) {
            // Caso seja um array direto
            this.resultados = response;
            this.totalItens = response.length;
            this.totalPaginas = 1;
          } else if (response.itens && Array.isArray(response.itens)) {
            // Caso tenha a estrutura de paginação
            this.resultados = response.itens;
            this.totalItens = response.totalItens || response.itens.length;
            this.totalPaginas = response.totalPaginas || 1;
            this.paginaAtual = response.paginaAtual || 1;
          } else {
            // Estrutura desconhecida
            console.error('Estrutura de resposta desconhecida:', response);
            this.erroCarregamento = true;
            this.mensagemErro = 'Formato de resposta inesperado.';
          }
        } else {
          this.resultados = [];
          this.totalItens = 0;
          this.totalPaginas = 0;
        }

        this.aplicarNomesResolvidosNosResultados();
        this.atualizarListaNomesUsuarios();
        this.resolverNomesUsuariosPorId();

        this.carregando = false;
      },
      error: (erro) => {
        console.error('Erro ao carregar dados de auditoria:', erro);
        this.erroCarregamento = true;
        this.mensagemErro = 'Falha ao carregar os dados. Por favor, tente novamente.';
        this.carregando = false;
        this.resultados = [];
      }
    });
  }

  limparFiltros(): void {
    // Reset do formulário mas mantendo a data atual como default
    const hoje = new Date();
    const dataHojeFormatada = this.formatDataParaInput(hoje);
    
    this.filtroForm.reset({
      entidade: '',
      acao: '',
      dataInicio: dataHojeFormatada,
      dataFim: dataHojeFormatada,
      nomeUsuario: '' // reset do novo campo
    });

    this.carregarDados();
  }

  trocarPagina(numeroPagina: number): void {
    if (numeroPagina >= 1 && numeroPagina <= this.totalPaginas && numeroPagina !== this.paginaAtual) {
      this.paginaAtual = numeroPagina;
      this.carregarDados(false);
    }
  }

  formatarData(data: string): string {
  if (!data) return '-';
  const formattedDate = this.datePipe.transform(data, 'dd/MM/yyyy HH:mm:ss');
  return formattedDate || '-';
  }

  formatarResumo(resumo: string): string {
    if (!resumo) return '-';

    return resumo
      .replace(/'S'/g, "'Validado'")
      .replace(/'N'/g, "'Invalido'");
  }
  
  // Helper para paginação
  get paginas(): number[] {
    const paginas = [];
    const totalPaginas = this.totalPaginas;
    const atual = this.paginaAtual;
    
    let inicio = Math.max(1, atual - 2);
    let fim = Math.min(totalPaginas, inicio + 4);
    
    // Ajustar início se estamos próximos do fim
    if (fim - inicio < 4) {
      inicio = Math.max(1, fim - 4);
    }
    
    for (let i = inicio; i <= fim; i++) {
      paginas.push(i);
    }
    
    return paginas;
  }

  getCorBadge(acao: string): string {
    if (acao?.includes('Exportacao')) {
      if (acao.includes('Removida') || acao.includes('Remocao')) {
        return 'badge-danger';
      }

      if (acao.includes('Erro')) {
        return 'badge-danger';
      }

      if (acao.includes('Sucesso')) {
        return 'badge-success';
      }

      if (acao.includes('Sem Dados')) {
        return 'badge-warning';
      }

      return 'badge-info';
    }

    switch (acao) {
      case 'Entrou no sistema':
        return 'badge-success-light';
      case 'Saiu do sistema':
        return 'badge-danger';
      case 'Logout Automático':
        return 'badge-danger';  
      case 'Iniciou o recadastramento':
      case 'Iniciou uma negativa de atendimento':
        return 'badge-orange';
      case 'Iniciou o Cadastro':
      case 'Registrou uma negativa de atendimento':
        return 'badge-success-dark';
      case 'Negativa de Atendimento':
        return 'badge-danger';
      case 'Atualizou o status da Vistoria':
        return 'badge-info';
      case 'Atribuiu uma vistoria':
        return 'badge-primary';
      case 'Exportacao Automatica - Sucesso':
      case 'Exportacao Manual Item - Sucesso':
        return 'badge-success';
      case 'Exportacao Automatica - Erro':
      case 'Exportacao Manual Item - Erro':
        return 'badge-danger';
      case 'Iniciou':
        return 'badge-success';
      case 'Mudança de Status para Validado':
        return 'badge-success';

      case 'Iniciou Análise de um Cadastro':
        return 'badge-info';
      case 'Mudança de Status para Invalido':
        return 'badge-warning'; 
      default:
        if (acao.includes('Realizou')) {
          return 'badge-info';
        } else if (acao.includes('Finalizou')) {
          return 'badge-warning';
        } else if (acao.includes('Exclusão')) {
          return 'badge-danger';
        } else if (acao.includes('Entrou no sistema')) {
          return 'badge-primary';
        } else {
          return 'badge-secondary';
        }
    }
  }

  // Método seguro para acessar propriedades possivelmente nulas
  getSeguro(objeto: any, propriedade: string, valorPadrao: any = '-'): any {
    try {
      return objeto && objeto[propriedade] ? objeto[propriedade] : valorPadrao;
    } catch (e) {
      return valorPadrao;
    }
  }
  abrirModalResumo(resumo: string): void {
    this.resumoModal = resumo;
    const modalElement = document.getElementById('modalResumo');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }

  fecharModalResumo(): void {
    this.resumoModal = null;
  }

  toggleResumo(index: number): void {
    this.resumoVisivel = this.resumoVisivel === index ? null : index;
  }

  acaoQuebrada(acao: string): string {
    if (!acao) return '';
    const palavras = acao.split(' ');
    let resultado = '';
    for (let i = 0; i < palavras.length; i++) {
      resultado += palavras[i];
      if ((i + 1) % 3 === 0 && i !== palavras.length - 1) {
        resultado += '<br>';
      } else if (i !== palavras.length - 1) {
        resultado += ' ';
      }
    }
    return resultado;
  }

  private resolverNomesUsuariosPorId(): void {
    const idsParaResolver = Array.from(
      new Set(
        this.resultados
          .filter(item => this.precisaResolverNome(item))
          .map(item => item.usuarioId)
          .filter((id): id is string => typeof id === 'string' && id.trim().length > 0)
      )
    ).filter(id => !this.nomesPorUsuarioId.has(id));

    if (idsParaResolver.length === 0) {
      return;
    }

    forkJoin(
      idsParaResolver.map(id =>
        this.controllAppService.usuarioGetById(id).pipe(
          map(usuario => ({
            id,
            nome: (usuario?.nome || usuario?.userName || '').trim()
          })),
          catchError(() => of({ id, nome: '' }))
        )
      )
    ).subscribe({
      next: (usuariosResolvidos) => {
        usuariosResolvidos.forEach(usuario => {
          if (usuario.nome) {
            this.nomesPorUsuarioId.set(usuario.id, usuario.nome);
          }
        });

        this.aplicarNomesResolvidosNosResultados();
        this.atualizarListaNomesUsuarios();
      }
    });
  }

  private aplicarNomesResolvidosNosResultados(): void {
    this.resultados = this.resultados.map(item => {
      const nomeAtual = (item.nomeUsuario || '').trim();
      const usuarioId = (item.usuarioId || '').toString();
      const nomeResolvido = usuarioId ? this.nomesPorUsuarioId.get(usuarioId) : undefined;

      if (nomeResolvido && (this.ehGuid(nomeAtual) || !nomeAtual)) {
        return { ...item, nomeUsuario: nomeResolvido };
      }

      return item;
    });
  }

  private atualizarListaNomesUsuarios(): void {
    this.nomesUsuarios = Array.from(
      new Set(
        this.resultados
          .map(item => (item.nomeUsuario || '').trim())
          .filter(nome => nome.length > 0 && !this.ehGuid(nome))
      )
    ).sort((a, b) => a.localeCompare(b));
  }

  private precisaResolverNome(item: AuditoriaItem): boolean {
    const nome = (item.nomeUsuario || '').trim();
    return !nome || this.ehGuid(nome);
  }

  private ehGuid(valor: string): boolean {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(valor);
  }
}
